// extracted by mini-css-extract-plugin
export default {"calendar":"style_calendar__Olx0r","eventTile":"style_eventTile__kZWfu"};